import {deserializeFolder, SerializedFolder} from "../../src/entities/Folder";
import { WebClient } from "./server/WebClient";

export interface SaveFolderRequest {
    id: string; 
    parentId?: string; 
    name: string;
    isStarred: boolean;
}

export const FolderService = {
    getFolder: (id: string) => WebClient.Get(`api/Folders/GetFolder/${id}`, deserializeFolder),
    save: (builderAssetToSave: SaveFolderRequest) => WebClient.Post.Validated(`api/Folders/SaveFolder/`, builderAssetToSave, deserializeFolder),
    createFolder: (name: string, parentId: string | null) => WebClient.Post.Validated(`api/Folders/CreateFolder`, { name, parentId }, deserializeFolder),
    setStarredFolder: (id: string, isStarred: boolean) => WebClient.Put.Validated(`api/Folders/SetStarredFolder`, {id, isStarred}, deserializeFolder),
    setFolderName: (id: string, name: string) => WebClient.Put.Validated(`api/Folders/SetNameFolder`, {id, name}, deserializeFolder),
    deleteFolder: (id: string) => WebClient.Delete(`api/Folders/DeleteFolder/${id}`),
    undeleteFolder: (id: string) => WebClient.Put.Validated(`api/Folders/UndeleteFolder/`, {id}, deserializeFolder),
    getFolders: () => WebClient.Get("api/Folders/GetFolders", (serializedFolders: SerializedFolder[]) => serializedFolders.map(deserializeFolder)),
    moveFolder: (id: string, parentId: string | null) => WebClient.Put.Validated(`api/Folders/MoveFolder`, {id, parentId}, deserializeFolder),
}